<div class="space-y-6">
  <!-- 1. RESUMEN EJECUTIVO DEL CUERPO TÉCNICO -->
  <div class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-5 space-y-4 shadow-xs transition-colors">
    <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-xl bg-slate-100 dark:bg-slate-800 text-slate-800 dark:text-slate-100 flex items-center justify-center shrink-0 border border-slate-200 dark:border-slate-700">
          <app-icon name="users" [size]="20" />
        </div>
        <div>
          <div class="flex items-center gap-2">
            <h3 class="text-base font-bold text-slate-900 dark:text-white">{{ game.t('staff.title') }}</h3>
          </div>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
            Especialistas que potencian el rendimiento competitivo de la plantilla en cada partido disputado.
          </p>
        </div>
      </div>

      <!-- Indicador de Cupo de Formación de la Jornada -->
      <div class="flex items-center gap-2 shrink-0">
        @if (isSlotAvailable()) {
          <div class="px-3.5 py-2 rounded-xl border text-xs font-semibold flex items-center gap-2 bg-emerald-50 dark:bg-emerald-950/40 border-emerald-200 dark:border-emerald-800/80 text-emerald-800 dark:text-emerald-300">
            <app-icon name="check-circle" [size]="15" class="text-emerald-600 dark:text-emerald-400" />
            <span>Cupo de jornada disponible</span>
          </div>
        } @else if (isSlotLimitReached()) {
          <div class="px-3.5 py-2 rounded-xl border text-xs font-semibold flex items-center gap-2 bg-amber-50 dark:bg-amber-950/40 border-amber-200 dark:border-amber-800/80 text-amber-800 dark:text-amber-300">
            <app-icon name="clock" [size]="15" class="text-amber-600 dark:text-amber-400" />
            <span>Cupo agotado esta jornada</span>
          </div>
        } @else {
          <div class="px-3.5 py-2 rounded-xl border text-xs font-semibold flex items-center gap-2 bg-slate-50 dark:bg-slate-950 border-slate-200 dark:border-slate-800 text-slate-600 dark:text-slate-400">
            <span>{{ slotLabel() }}</span>
          </div>
        }
      </div>
    </div>

    <!-- Tira de KPIs de Staff (Consistente con Economía y Estadio) -->
    <div class="grid grid-cols-2 sm:grid-cols-4 gap-3 p-3.5 bg-slate-50 dark:bg-slate-950/70 border border-slate-200 dark:border-slate-800/80 rounded-xl text-xs">
      <div>
        <div class="text-slate-500 dark:text-slate-400 text-[11px]">Nivel Medio Staff</div>
        <div class="font-bold text-slate-900 dark:text-white font-mono text-sm sm:text-base mt-0.5">
          {{ averageRating() | number:'1.1-1' }} ★
        </div>
        <div class="text-[10px] text-slate-400 dark:text-slate-500 mt-0.5">
          Calidad promedio (máx 5.0)
        </div>
      </div>

      <div>
        <div class="text-slate-500 dark:text-slate-400 text-[11px]">Bonificación Media</div>
        <div class="font-bold text-emerald-600 dark:text-emerald-400 font-mono text-sm sm:text-base mt-0.5">
          +{{ averageModifier() | number:'1.1-1' }}%
        </div>
        <div class="text-[10px] text-slate-400 dark:text-slate-500 mt-0.5">
          Modificador en competición
        </div>
      </div>

      <div>
        <div class="text-slate-500 dark:text-slate-400 text-[11px]">Masa Salarial Staff</div>
        <div class="font-bold text-slate-900 dark:text-white font-mono text-sm sm:text-base mt-0.5">
          {{ moneyM(totalAnnualSalary()) }}
        </div>
        <div class="text-[10px] text-slate-400 dark:text-slate-500 mt-0.5">
          Coste de nóminas anual
        </div>
      </div>

      <div>
        <div class="text-slate-500 dark:text-slate-400 text-[11px]">Cupo de Formación</div>
        <div class="font-bold font-mono text-sm sm:text-base mt-0.5"
          [class.text-emerald-600]="isSlotAvailable()"
          [class.text-amber-600]="!isSlotAvailable()">
          @if (isSlotAvailable()) { 1 disponible } @else { 0 disponible }
        </div>
        <div class="text-[10px] text-slate-400 dark:text-slate-500 mt-0.5">
          @if (completionMatchday()) {
            Vence en jornada {{ completionMatchday() }}
          } @else {
            1 mejora por jornada
          }
        </div>
      </div>
    </div>
  </div>

  <!-- AVISO DE ERROR / CONEXIÓN -->
  @if (error()) {
    <div role="alert" class="p-4 bg-rose-50 dark:bg-rose-950/50 border border-rose-200 dark:border-rose-800 rounded-2xl flex items-start justify-between gap-3 text-xs text-rose-700 dark:text-rose-300">
      <div class="flex items-start gap-2.5">
        <app-icon name="alert-circle" [size]="18" class="shrink-0 text-rose-600 dark:text-rose-400 mt-0.5" />
        <div>
          <strong class="font-bold">Aviso del cuerpo técnico</strong>
          <p class="mt-0.5 leading-relaxed">{{ error() }}</p>
        </div>
      </div>
      <button
        type="button"
        (click)="refresh()"
        class="shrink-0 px-3.5 py-1.5 bg-rose-100 hover:bg-rose-200 dark:bg-rose-900 dark:hover:bg-rose-800 rounded-xl text-rose-800 dark:text-rose-200 font-semibold cursor-pointer transition-colors"
      >
        Reintentar
      </button>
    </div>
  }

  <!-- BANNER DE REINTENTO PENDIENTE DE SEGURIDAD -->
  @if (retry()) {
    <div class="p-4 bg-amber-50 dark:bg-amber-950/50 border border-amber-200 dark:border-amber-800 rounded-2xl flex flex-col sm:flex-row sm:items-center justify-between gap-3 text-xs text-amber-900 dark:text-amber-200">
      <div class="flex items-center gap-2.5">
        <app-icon name="rotate-ccw" [size]="18" class="shrink-0 text-amber-600 dark:text-amber-400" />
        <div>
          <strong class="font-bold">Operación pendiente de confirmación</strong>
          <p class="text-[11px] text-amber-800 dark:text-amber-300 mt-0.5">
            Existe una solicitud enviada que no se confirmó en la sesión. Reinténtala con el mismo identificador para evitar cobros duplicados.
          </p>
        </div>
      </div>
      <button
        type="button"
        (click)="retryRequest()"
        [disabled]="submitting() || loading()"
        class="shrink-0 px-4 py-2 bg-amber-600 hover:bg-amber-700 active:bg-amber-800 text-white font-bold rounded-xl shadow-xs transition-colors cursor-pointer disabled:opacity-50 flex items-center gap-1.5"
      >
        <app-icon name="rotate-ccw" [size]="14" [class.animate-spin]="submitting()" />
        <span>{{ submitting() ? 'Reintentando…' : 'Reintentar solicitud' }}</span>
      </button>
    </div>
  }

  <!-- NOTIFICACIÓN DE ÚLTIMA OPERACIÓN APLICADA -->
  @if (lastOperation(); as operation) {
    <div role="status" class="px-4 py-3 rounded-2xl bg-emerald-50 dark:bg-emerald-950/60 border border-emerald-200 dark:border-emerald-800 text-xs text-emerald-800 dark:text-emerald-300 flex items-center justify-between gap-3">
      <div class="flex items-center gap-2.5">
        <app-icon name="check-circle" [size]="18" class="text-emerald-600 dark:text-emerald-400 shrink-0" />
        <span>
          <strong>{{ role(operation.staffType) }}</strong>: {{ operationLabel(operation.status) }} ({{ operation.fromRating }} ★ → {{ operation.toRating }} ★)
        </span>
      </div>
      <button type="button" (click)="lastOperation.set(null)" class="text-emerald-700 hover:text-emerald-900 dark:text-emerald-300 cursor-pointer text-xs font-semibold">
        Cerrar
      </button>
    </div>
  }

  <!-- 2. CATÁLOGO DE LOS 4 DEPARTAMENTOS DE STAFF -->
  <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 sm:gap-5">
    @for (member of members(); track member.id) {
      @let meta = getDepartmentMeta(member.staffType);
      @let pending = active(member.id);

      <div
        class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-5 flex flex-col justify-between space-y-4 shadow-xs transition-colors"
        [class.ring-2]="!!pending"
        [class.ring-emerald-500/40]="!!pending"
        [class.border-emerald-300]="!!pending"
        [class.dark:border-emerald-700]="!!pending"
      >
        <div class="space-y-3.5">
          <!-- Cabecera de Tarjeta: Icono, Título y Estado -->
          <div class="flex items-start justify-between gap-2">
            <div class="flex items-center gap-2.5">
              <div class="w-9 h-9 rounded-xl flex items-center justify-center shrink-0 bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200 border border-slate-200 dark:border-slate-700">
                <app-icon [name]="meta.icon" [size]="18" />
              </div>
              <div>
                <h4 class="text-sm font-bold text-slate-900 dark:text-white leading-tight">
                  {{ meta.roleName }}
                </h4>
                <div class="text-[11px] font-semibold text-slate-500 dark:text-slate-400">
                  {{ meta.areaName }}
                </div>
              </div>
            </div>

            <!-- Estado del departamento -->
            @if (pending) {
              <span class="inline-flex items-center gap-1.5 px-2.5 py-1 text-[10px] font-bold rounded-lg bg-emerald-50 dark:bg-emerald-950/70 text-emerald-700 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800 animate-pulse">
                <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
                En formación
              </span>
            } @else if (member.starRating >= 5) {
              <span class="px-2.5 py-1 text-[10px] font-bold rounded-lg bg-amber-50 dark:bg-amber-950/70 text-amber-700 dark:text-amber-400 border border-amber-200 dark:border-amber-800">
                Nivel Máx (5★)
              </span>
            }
          </div>

          <!-- Explicación de impacto táctico en el juego -->
          <p class="text-xs text-slate-500 dark:text-slate-400 leading-relaxed min-h-[36px]">
            {{ meta.benefit }}
          </p>

          <!-- Tarjeta de Nivel y Estrellas -->
          <div class="p-3.5 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 space-y-2.5">
            <div class="flex items-center justify-between">
              <span class="text-xs font-semibold text-slate-600 dark:text-slate-400">
                {{ game.t('staff.quality_level') }}
              </span>
              <div class="flex items-baseline gap-1">
                <span class="text-xl font-black font-mono text-slate-900 dark:text-white">
                  {{ member.starRating | number:'1.1-1' }}
                </span>
                <span class="text-xs font-bold text-slate-400">/ 5.0</span>
              </div>
            </div>

            <!-- Estrellas limpias estilo juego de fútbol -->
            <div class="flex items-center gap-1" [title]="'Nivel actual: ' + member.starRating + ' de 5'">
              @for (st of getStarStates(member.starRating); track $index) {
                @if (st === 'full') {
                  <svg class="w-4 h-4 text-amber-400 fill-amber-400 shrink-0" viewBox="0 0 20 20" aria-hidden="true">
                    <path d="M10 1 L12.5 7 L19 7.5 L14 12 L15.5 18.5 L10 15 L4.5 18.5 L6 12 L1 7.5 L7.5 7 Z"/>
                  </svg>
                } @else if (st === 'half') {
                  <svg class="w-4 h-4 text-amber-400 shrink-0" viewBox="0 0 20 20" aria-hidden="true">
                    <defs>
                      <linearGradient [id]="'staffHalfGrad-' + member.id + '-' + $index" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="50%" stop-color="#f59e0b" />
                        <stop offset="50%" stop-color="#cbd5e1" stop-opacity="0.3" />
                      </linearGradient>
                    </defs>
                    <path [attr.fill]="'url(#staffHalfGrad-' + member.id + '-' + $index + ')'" d="M10 1 L12.5 7 L19 7.5 L14 12 L15.5 18.5 L10 15 L4.5 18.5 L6 12 L1 7.5 L7.5 7 Z"/>
                  </svg>
                } @else {
                  <svg class="w-4 h-4 text-slate-200 dark:text-slate-800 fill-slate-200 dark:fill-slate-800 shrink-0" viewBox="0 0 20 20" aria-hidden="true">
                    <path d="M10 1 L12.5 7 L19 7.5 L14 12 L15.5 18.5 L10 15 L4.5 18.5 L6 12 L1 7.5 L7.5 7 Z"/>
                  </svg>
                }
              }
            </div>

            <!-- Barra de progreso hacia el nivel máximo -->
            <div class="w-full h-1.5 rounded-full bg-slate-200 dark:bg-slate-800 overflow-hidden">
              <div
                class="h-full rounded-full bg-emerald-600 dark:bg-emerald-500 transition-all duration-300"
                [style.width.%]="(member.starRating / 5) * 100"
              ></div>
            </div>
          </div>

          <!-- Cuadro de métricas actuales: Modificador y Salario Anual -->
          <div class="grid grid-cols-2 gap-2 text-xs">
            <div class="p-2.5 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800">
              <span class="text-slate-500 dark:text-slate-400 text-[10px] uppercase font-bold block">
                {{ game.t('staff.modifier') }}
              </span>
              <span class="font-bold font-mono text-sm text-emerald-600 dark:text-emerald-400 mt-0.5 block">
                +{{ member.performanceModifierPct }}%
              </span>
            </div>

            <div class="p-2.5 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800">
              <span class="text-slate-500 dark:text-slate-400 text-[10px] uppercase font-bold block">
                {{ game.t('staff.annual_cost') }}
              </span>
              <span class="font-bold font-mono text-xs sm:text-sm text-slate-900 dark:text-white mt-0.5 block truncate" [title]="money(member.annualCostReference)">
                {{ moneyM(member.annualCostReference) }}
              </span>
            </div>
          </div>

          <!-- Previsualización de próximo nivel o Formación activa -->
          @if (pending) {
            <div class="p-3 bg-emerald-50 dark:bg-emerald-950/60 border border-emerald-200 dark:border-emerald-800 rounded-xl text-xs space-y-1">
              <div class="flex items-center gap-1.5 text-emerald-800 dark:text-emerald-300 font-bold">
                <span class="inline-flex animate-[spin_8s_linear_infinite] motion-reduce:animate-none"><app-icon name="clock" [size]="13" class="text-emerald-600 dark:text-emerald-400" /></span>
                <span>Formación en progreso</span>
              </div>
              <div class="flex justify-between items-center text-[11px] text-slate-700 dark:text-slate-300">
                <span>Objetivo:</span>
                <strong class="font-mono">{{ pending.operation.fromRating }} → {{ pending.operation.toRating }} ★</strong>
              </div>
              <div class="text-[10px] text-slate-500 dark:text-slate-400 pt-1 border-t border-emerald-200/60 dark:border-emerald-800/60">
                Finaliza al cierre de la jornada <strong>{{ pending.training?.completionMatchdayNumber ?? completionMatchday() }}</strong>
              </div>
            </div>
          } @else if (member.starRating < 5) {
            <div class="p-2.5 bg-slate-50/60 dark:bg-slate-950/40 rounded-xl border border-slate-200/60 dark:border-slate-800/60 text-xs flex items-center justify-between">
              <span class="text-slate-500 dark:text-slate-400 text-[11px]">
                Siguiente nivel:
              </span>
              <div class="flex items-center gap-2">
                <span class="font-bold font-mono text-slate-900 dark:text-white text-xs">
                  {{ nextRating(member) }} ★
                </span>
                <span class="font-bold font-mono text-emerald-600 dark:text-emerald-400 text-[11px]">
                  (+{{ projectedModifier(member) }}%)
                </span>
              </div>
            </div>
          }
        </div>

        <!-- Botón de acción principal -->
        <div class="pt-3 border-t border-slate-100 dark:border-slate-800">
          <button
            type="button"
            (click)="requestQuote(member)"
            [disabled]="!canQuote(member)"
            class="w-full py-2.5 px-3 text-xs font-semibold rounded-xl transition-all flex items-center justify-center gap-1.5 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
            [ngClass]="{
              'bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white shadow-xs active:scale-98': canQuote(member),
              'bg-slate-100 dark:bg-slate-800 text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-slate-700': !canQuote(member)
            }"
          >
            @if (quotingMemberId() === member.id) {
              <div class="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Consultando presupuesto…</span>
            } @else if (member.starRating >= 5) {
              <app-icon name="award" [size]="14" class="text-amber-500" />
              <span>Nivel máximo alcanzado</span>
            } @else if (pending) {
              <span class="inline-flex animate-[spin_8s_linear_infinite] motion-reduce:animate-none"><app-icon name="clock" [size]="14" class="text-emerald-500" /></span>
              <span>Mejora en curso</span>
            } @else if (isSlotLimitReached()) {
              <app-icon name="clock" [size]="14" />
              <span>Cupo agotado esta jornada</span>
            } @else {
              <app-icon name="arrow-up-right" [size]="14" />
              <span>Mejorar nivel (+{{ increment(member) }} ★)</span>
            }
          </button>
        </div>
      </div>
    } @empty {
      <div class="col-span-full py-12 text-center text-slate-500 dark:text-slate-400 bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-8 space-y-3">
        <app-icon name="users" [size]="32" class="mx-auto opacity-40 text-slate-400" />
        <p class="text-sm font-semibold">
          {{ loading() ? 'Cargando cuerpo técnico del club…' : 'No se encontraron preparadores registrados.' }}
        </p>
        @if (!loading()) {
          <button type="button" (click)="refresh()" class="px-4 py-2 bg-emerald-600 text-white text-xs font-semibold rounded-xl cursor-pointer">
            Reintentar carga
          </button>
        }
      </div>
    }
  </div>

  <!-- ============================================================= -->
  <!-- MODAL DE PRESUPUESTO OFICIAL (Idéntico a Remodelación Estadio) -->
  <!-- ============================================================= -->
  @if (quote(); as q) {
    <div
      class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-xs transition-opacity"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl max-w-lg w-full p-6 shadow-2xl space-y-5 text-slate-900 dark:text-white"
      >
        <!-- Cabecera del modal -->
        <div class="flex items-center justify-between border-b border-slate-100 dark:border-slate-800 pb-3">
          <div class="flex items-center gap-2">
            <app-icon name="award" [size]="20" class="text-emerald-600 dark:text-emerald-400" />
            <h3 class="text-base font-bold">Presupuesto de Mejora de Staff</h3>
          </div>
          <button
            type="button"
            (click)="closeQuoteModal()"
            [disabled]="submitting()"
            class="p-1 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors cursor-pointer disabled:opacity-50"
            title="Cerrar presupuesto"
          >
            <app-icon name="x" [size]="18" />
          </button>
        </div>

        <div class="space-y-3 text-xs">
          <!-- Desglose de Operación -->
          <div class="p-4 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 space-y-2.5">
            <div class="flex justify-between items-center">
              <span class="text-slate-500 dark:text-slate-400">Departamento:</span>
              <span class="font-bold">{{ role(q.staffType) }}</span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-slate-500 dark:text-slate-400">Salto de nivel de calidad:</span>
              <span class="font-bold font-mono text-slate-900 dark:text-white">
                {{ q.fromRating }} ★ → {{ q.toRating }} ★
              </span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-slate-500 dark:text-slate-400">Inversión en formación:</span>
              <span class="font-bold font-mono text-emerald-700 dark:text-emerald-400 text-sm">
                {{ money(q.quotedCost) }}
              </span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-slate-500 dark:text-slate-400">Ficha anual en nómina:</span>
              <span class="font-bold font-mono text-slate-800 dark:text-slate-200">
                {{ money(q.annualSalaryReference) }}
              </span>
            </div>
            <div class="flex justify-between items-center pt-1 border-t border-slate-200 dark:border-slate-800">
              <span class="text-slate-500 dark:text-slate-400">Duración del proceso:</span>
              <span class="font-bold text-slate-800 dark:text-slate-200">
                1 jornada oficial
              </span>
            </div>
          </div>

          <!-- Comparación de Tesorería del Club -->
          @if (availableBalance() !== null) {
            <div class="p-3.5 bg-slate-50/80 dark:bg-slate-950/80 rounded-xl border border-slate-200 dark:border-slate-800 space-y-2 text-xs">
              <div class="flex justify-between items-center text-slate-600 dark:text-slate-400">
                <span>Saldo disponible actual:</span>
                <strong class="font-mono text-slate-900 dark:text-white">{{ money(availableBalance()!) }}</strong>
              </div>
              <div class="flex justify-between items-center text-slate-600 dark:text-slate-400">
                <span>Coste presupuestado de la mejora:</span>
                <strong class="font-mono text-rose-600 dark:text-rose-400">-{{ money(q.quotedCost) }}</strong>
              </div>
              <div class="flex justify-between items-center pt-2 border-t border-slate-200 dark:border-slate-800 font-bold">
                <span>Saldo resultante proyectado:</span>
                <span
                  class="font-mono"
                  [class.text-emerald-600]="(availableBalance()! - q.quotedCost) >= 0"
                  [class.text-rose-600]="(availableBalance()! - q.quotedCost) < 0"
                >
                  {{ money(availableBalance()! - q.quotedCost) }}
                </span>
              </div>
            </div>
          }

          <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-relaxed italic">
            La mejora de staff consumirá el cupo de formación de la jornada activa. El nuevo nivel de calidad y la ficha salarial se aplicarán al concluir el partido de la jornada.
          </p>

          <!-- Aviso de saldo insuficiente si aplica -->
          @if (!canAffordQuote()) {
            <div role="alert" class="p-3 bg-rose-50 dark:bg-rose-950/60 border border-rose-200 dark:border-rose-800 rounded-xl text-xs text-rose-700 dark:text-rose-300 flex items-center gap-2">
              <app-icon name="alert-circle" [size]="16" class="shrink-0 text-rose-500" />
              <p class="font-semibold">Saldo disponible insuficiente en tesorería para formalizar este contrato.</p>
            </div>
          }
        </div>

        <!-- Botones de Acción del Modal -->
        <div class="flex items-center justify-end gap-2.5 pt-2 border-t border-slate-100 dark:border-slate-800">
          <button
            type="button"
            (click)="closeQuoteModal()"
            [disabled]="submitting()"
            class="px-4 py-2 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-xl text-xs font-semibold transition-colors cursor-pointer disabled:opacity-50"
          >
            Cancelar
          </button>
          <button
            type="button"
            (click)="confirm()"
            [disabled]="!game.canAction('upgradeClub') || (submitting() || loading() || retry() || !canAffordQuote() || !!error() || !isSlotAvailable())"
            class="px-5 py-2.5 bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white rounded-xl text-xs font-bold shadow-xs transition-all cursor-pointer active:scale-98 disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-2"
          >
            @if (submitting()) {
              <div class="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Formalizando contrato…</span>
            } @else {
              <app-icon name="check-circle" [size]="15" />
              <span>Confirmar mejora por {{ money(q.quotedCost) }}</span>
            }
          </button>
        </div>
      </div>
    </div>
  }
</div>
